
import * as React from "react";
import { useState,useEffect} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import Button from "@mui/material/Button";
import axios from "axios";
import logo from '../images/logo.png';
import registrationValidation from "./registrationValidation";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { AppUrl,DRREGISTRATION,GET_STATE,GET_CITY } from "../endpoints/Apiendpoints";
import Modal from '@mui/material/Modal';
import { color } from "@mui/system";
import { green } from "@mui/material/colors";

const DoctorRegistration = () => {

    const [name, setName]=useState("");
    const [email, setEmail]=useState("");
    const [phone, setPhone]=useState("");
    const [qualification, setQualification]=useState("");
    const [specialization, setSpecialization]=useState("");
    const [addqualification, setAddqualification]=useState("");
    const [nmcnumbr, setNmcnumbr]=useState("");;
    const [approxhours, setApproxhours]=useState("");
    const [consulttype, setConsultype]=useState(0);
    const [checkinperson, setcheckinperson]=useState(false);
    const [checkonline, setcheckonline]=useState(false);
    const [checkpsychiat, setPsychiat]=useState(false);
    const [checkpsychologi, setpsychologi]=useState(false);
    const [checkcounselor, setCounselor]=useState(false);
    // const [Profession, setProfession]=useState(0);
    const [errors, setErrors] = useState({});
    const [stateslist, setStateList] = useState([]);
    const [selectedstate, setSelectedstate] = useState("");
    const [citieslist, setCitiesList] = useState([]);
    const [selectedcity, setSelectedcity] = useState("");
    const [yearecper, setYearecper] = useState("");
    const [acceptterms, setAcceptHandle] = useState(false);
    const [donotacceptterms, setdonotacceptterms] = useState(false);
    
    
    const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  

    const handleregistration =async(e)=> {
        e.preventDefault()
    debugger
        const data = {
            dname:name,
            demail:email,
            dphone:phone,
            dqualification:qualification,
            daddqualification:addqualification,
            dspecialization:specialization,
            dnmcnumbr:nmcnumbr,
            dapproxhours:approxhours,
            dstate:selectedstate,
            dyearecper:yearecper,
            dcity:selectedcity,
            dconsulttype:consulttype,
            dProfession:checkpsychiat + ',' + checkpsychologi + ',' + checkcounselor,
            dacceptterms :acceptterms
        }


                const validationErrors = registrationValidation(data)
                setErrors(validationErrors)

                if(Object.keys(validationErrors).length <= 0)
                    {

                      const formData = new FormData();
                      formData.append("name", data.dname.trim());
                      formData.append("email", data.demail.trim());
                      formData.append("phone", data.dphone.trim());
                      formData.append("qualification", data.dqualification.trim());
                      formData.append("add_qualification", data.daddqualification.trim());
                      formData.append("specialization", data.dspecialization.trim());
                      formData.append("nmc_numbr", data.dnmcnumbr.trim());
                      formData.append("consultation_type", data.dconsulttype);
                      formData.append("profession", data.dProfession);
                      formData.append("approxhours", data.dapproxhours.trim());
                      formData.append("year_exp", data.dyearecper.trim());
                      formData.append("state", data.dstate.trim());
                      formData.append("city", data.dcity.trim());
                  try {
                        const response = await axios.post(AppUrl + DRREGISTRATION,formData);
                        
                  if(response)
                  {
                    if(response.data.success==true)
                    {
                      alert('Successfully added')
                      window.location.reload()
                    }else{
                      alert('Email address already exist please chose different email')
                    }
                    
                   
                  }
                      } catch (error) {
                        console.log("Error fetching roles:", error);
                      }


                    }


 }



          const handleState = async () => {
          
            const response = await axios.get(AppUrl + GET_STATE);

            if(response)
            {
              if (Array.isArray(response.data.states)) {
                setStateList(response.data.states)
              
              }
            }else{
              console.log('error state list',response)
            }
          

            

          }


const handleCity = async(statename)=>{

  if(statename)
    {
      const formCity = new FormData();
            formCity.append("state", statename);
         const response = await axios.post(AppUrl + GET_CITY,formCity);
         if (Array.isArray(response.data.cities)) {
          setCitiesList(response.data.cities)
         
        }
         console.log('city',response.data)
    }
}
    const checkinpersonchange = (e)=>
    { 
        setcheckinperson(e.target.checked)
       
        setConsultype(1)
        if(e.target.checked == true && checkonline == true){
          setConsultype(3)
        }
    }
    const checkonlinechange = (e)=>
    { 
        setcheckonline(e.target.checked)
        
        setConsultype(2)
        if(checkinperson == true && e.target.checked == true){
          setConsultype(3)
        }
    }

    const acceptHandle = (e)=>
    {
      setAcceptHandle(e.target.checked)
      setdonotacceptterms(false)
      setOpen(false)
      resetError("erdacceptterms")
    }
    
    
    const notaccepthandle = (e)=>
    {
     setdonotacceptterms(e.target.checked)
      setOpen(false)
      setAcceptHandle(false)
 
    }


    const checkPsychiatchange = (e)=>
    { 
        setPsychiat(e.target.checked)
        // setProfession(1)
    }

    const checkpsychologichange = (e)=>
    { 
        setpsychologi(e.target.checked)
        // setProfession(2)
    }
    
    const checkCounselorchange = (e)=>
    { 
        setCounselor(e.target.checked)
        // setProfession(3)
    }

  
   
    const handleselectstate = (e)=>
    { 
      
      const statename=e.target.value;
      setSelectedstate(statename)
      handleCity(statename)
    }

    const handleselectcity = (e)=>
    { 
      const cityname=e.target.value;
      setSelectedcity(cityname)
      
    }

  

    const resetError = (fieldName) => {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: '',
        }));  
      };


 useEffect(() => {
    handleState();
    // handleCity();
  }, []);
      

    return (

        <Paper elevation={3} sx={{ marginRight: "15%", marginLeft: "15%" }}>
        <Box sx={{ padding: 5 }}>
         
          
      <Grid container spacing={3}>
      <Grid item xs={4} sm={4}/>
      <Grid item xs={4} sm={4}   sx={{ paddingLeft: "110px !important"}}>
      <img
        src={logo}
       
      />
      </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={2} sm={2}/>
      <Grid item xs={10} sm={10}>
      <Typography variant="h4" gutterBottom sx={{ paddingLeft:"100px",fontWeight: 'bold', m: 1 }}>
      Counselling Professional Application
          </Typography>
      </Grid>
      </Grid>

        <Grid container spacing={3} sx={{ paddingBottom: 5, m: 1 }}>
         <Grid item xs={1} sm={1}>
         </Grid>
            <Grid item xs={10} sm={10} sx={{ backgroundColor:"#efefef" }}>
            <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold', m: 1 }}>
            "Ananth Jeevan is a not for profit organization. We seek your help in catering to the mental health needs in various locations and languages across India as we assign cases to you. Please await the confirmation of your selection."
          </Typography>

              
            </Grid>
        </Grid>

          <Grid container spacing={3}>
          
            
            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Name
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
            <TextField
                required
                id="name"
                name="name"
                label="Name"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                onBlur={() => resetError("erdname")}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              {errors.erdname && (
              <FormHelperText sx={{fontSize:"medium"}} error>
                {errors.erdname}
              </FormHelperText>
            )}
            </Grid>

            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Email
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                id="Email"
                name="Email"
                label="Email"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                onBlur={() => resetError("erdemail")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.erdemail && (
                                  <FormHelperText sx={{fontSize:"medium"}} error>
                                    {errors.erdemail}
                                  </FormHelperText>
                                )}
            </Grid>

            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Cell #
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                type="number"
                name="Phone"
                label="Cell #"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                onBlur={() => resetError("erdphone")}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
                  {errors.erdphone && (
                                  <FormHelperText sx={{fontSize:"medium"}} error>
                                    {errors.erdphone}
                                  </FormHelperText>
                                )}
            </Grid>

            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Qualification
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                id="Qualification"
                name="Qualification"
                label="Qualification"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                onBlur={() => resetError("erdqualification")}
                value={qualification}
                onChange={(e) => setQualification(e.target.value)}
              />
              {errors.erdqualification && (
                                  <FormHelperText sx={{fontSize:"medium"}} error>
                                    {errors.erdqualification}
                                  </FormHelperText>
                                )}
            </Grid>
           
          
            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Specialization
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
            <TextField
                required
                id="Specialization"
                name="Specialization"
                label="Specialization"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                onBlur={() => resetError("erdspecialization")}
                value={specialization}
                onChange={(e) => setSpecialization(e.target.value)}
              />
               {errors.erdspecialization && (
                                  <FormHelperText sx={{fontSize:"medium"}} error>
                                    {errors.erdspecialization}
                                  </FormHelperText>
                                )}
            </Grid>
            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Add'l Qualifications
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                id="Additional Qualifications"
                name="Additional Qualifications"
                label="Additional Qualifications"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                onBlur={() => resetError("erdaddqualification")}
                value={addqualification}
                onChange={(e) => setAddqualification(e.target.value)}
              />
               {errors.erdaddqualification && (
                                  <FormHelperText sx={{fontSize:"medium"}} error>
                                    {errors.erdaddqualification}
                                  </FormHelperText>
                                )}
            </Grid>

            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                NMC Number
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
            <TextField
             
                label="NMC Registration Number"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                value={nmcnumbr}
                onChange={(e) => setNmcnumbr(e.target.value)}
              />
              
            </Grid>
            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Consultation Type
              </InputLabel>
              
              {errors.dconsulttype && (
                                  <FormHelperText sx={{fontSize:"medium"}} error>
                                    {errors.dconsulttype}
                                  </FormHelperText>
                                )}
            </Grid>
            <Grid item xs={12} sm={2}>
            
            <Checkbox
                checked={checkinperson}
                 onChange={checkinpersonchange}
                
              />

             
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700,
                  marginTop:"-35px"
                }}
              >
               In-Person
              </InputLabel>
                </Grid>
            <Grid item xs={12} sm={2}>
            
            <Checkbox
                 checked={checkonline}
                 onChange={checkonlinechange}
                
              />
                
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700,
                  marginTop:"-35px"
                }}
              >
                Online
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Profession
              </InputLabel>
              
              {errors.dconsulttype && (
                                  <FormHelperText sx={{fontSize:"medium"}} error>
                                    {errors.dconsulttype}
                                  </FormHelperText>
                                )}
            </Grid>
            <Grid item xs={12} sm={3}
            sx={{
              "&:hover": {  boxShadow: '0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 12px 17px 2px rgb(0 0 0 / 14%), 0px 5px 22px 4px rgb(0 0 0 / 12%)',},
              boxShadow: 1,
              borderRadius:"20px",
              margin:"0px 10px 0px 0px",
              backgroundColor:"#e9e7e7"
            }}
            onClick={checkPsychiatchange}
            >
            
            <Checkbox
                checked={checkpsychiat}
              />

             
              <InputLabel
                sx={{
                  
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700,
                  marginTop:"-35px"
                }}
              >
              Psychiatrist
              </InputLabel>
                </Grid>
            <Grid item xs={12} sm={3} 
             sx={{
              "&:hover": {  boxShadow: '0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 12px 17px 2px rgb(0 0 0 / 14%), 0px 5px 22px 4px rgb(0 0 0 / 12%)',},
              boxShadow: 1,
              borderRadius:"20px",
              margin:"0px 10px 0px 0px",
                  backgroundColor:"#e9e7e7"
                }}>
            
            <Checkbox
                checked={checkpsychologi}
                onChange={checkpsychologichange}
                
              />
                
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700,
                  marginTop:"-35px"
                }}
              >
                Psychologist
              </InputLabel>
            </Grid>
            
            <Grid item xs={12} sm={3} 
            sx={{
              "&:hover": {  boxShadow: '0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 12px 17px 2px rgb(0 0 0 / 14%), 0px 5px 22px 4px rgb(0 0 0 / 12%)',},
              boxShadow: 1,
              borderRadius:"20px",
              margin:"0px 10px 0px 0px",
                  backgroundColor:"#e9e7e7"
                }}>
            
            <Checkbox
                checked={checkcounselor}
                onChange={checkCounselorchange}
                
              />
                
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700,
                  marginTop:"-35px"
                }}
              >
                  Certified Counselor
              </InputLabel>
            </Grid>
            
            
            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
          Year's Of Experience
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                
                label="Professional Year's Of Experience"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                value={yearecper}
                onChange={(e) => setYearecper(e.target.value)}
              />
            </Grid>

            
            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Approx Available Hours
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                
                label=" Approx Available Hours Per Day/Week"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                multiline
                rows={2}
                value={approxhours}
                onChange={(e) => setApproxhours(e.target.value)}
              />
            </Grid>



            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                State
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
            <InputLabel
                sx={{
                  display: "flex",
                  backgroundColor:'#efefef',
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Choose State
              </InputLabel>
          <Select
            
            value={selectedstate}
            
            onChange={handleselectstate}
          >

            
            {stateslist.map((stateslist) => (
                        <MenuItem key={stateslist.city_state} value={stateslist.city_state}>
                          {stateslist.city_state}
                        </MenuItem>
                      ))}
          
          </Select>
        </FormControl>
            </Grid>


            <Grid item xs={12} sm={2}>
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                City
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
            
            <FormControl fullWidth>
            <InputLabel
                sx={{
                  display: "flex",
                  backgroundColor:'#efefef',
                  justifyContent: "center",
                  fontWeight: 700
                }}
              >
                Choose City
              </InputLabel>
          <Select
            
            value={selectedcity}
         
            onChange={handleselectcity}
          >

            
            {citieslist.map((citieslist) => (
                        <MenuItem key={citieslist.city_name} value={citieslist.city_name}>
                          {citieslist.city_name}
                        </MenuItem>
                      ))}
          
          </Select>
        </FormControl>
            </Grid>
          
            <Grid item xs={12} sm={5} 
            sx={{
              margin:"0px 10px 0px 0px",
              
                }}>
            
            <Checkbox
            checked={acceptterms}
            disabled
              />
                
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700,
                  marginTop:"-35px",
                  color:"green"
                }}
                onClick={handleOpen}
              >
                Please Read Terms And Conditions And Accept
              </InputLabel>
              {errors.erdacceptterms && (
              <FormHelperText sx={{fontSize:"medium"}} error>
                {errors.erdacceptterms}
              </FormHelperText>
            )}
            </Grid>

           
            
            <Grid item xs={12} sm={6} />
            
            <Grid item xs={12} sm={4}>
              <Button variant="contained" sx={{ color: "#101010" }} onClick={handleregistration}>
                Register
              </Button>
            </Grid>
            <Grid item xs={12} sm={5} />
          </Grid>
        </Box>

        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" sx={{ paddingLeft:"100px",fontWeight: 'bold'}}>
          Affiliation – Expression of Interest
          </Typography>
          
          <Typography  style={{ wordWrap: "break-word" }}>
          Dear Counselor - Doctor thank you for your interest and heart to help. Please go through the below and click on submit button to indicate your acceptance of the same.
          </Typography>

          <Typography style={{ wordWrap: "break-word" }}>
          I agree that by partnering with Ananth Jeevan, I shall abide by the terms and conditions outlined herein.
          </Typography>
          
      <Typography  sx={{fontWeight: 'bold'}}> Patient Privacy:</Typography><Typography > I understand the importance of maintaining privacy of personal data and agree to uphold confidentiality and adhere to all applicable data protection laws and regulations. I agree to share the details of the case and the outcome / result of the treatment to Ananth Jeevan.
      </Typography>
      <Typography  sx={{fontWeight: 'bold'}}>Ananth Jeevan Value System</Typography>
      <Typography >
      I will conduct my medical practice with the utmost professionalism and adhere to ethical standards apart from abiding by the values that Ananth Jeevan considers as important.
      </Typography>
      <Typography  sx={{fontWeight: 'bold'}}>Compliance with Laws:</Typography>

      <Typography >

      I shall comply with all applicable local, state, and national laws and regulations governing medical practice.</Typography>
      <Typography  sx={{fontWeight: 'bold'}}>Insurance and Licensing:</Typography>

      <Typography >
      I shall maintain valid medical licenses and insurance coverage as required by Ananth Jeevan and the Government
      </Typography>

      <Typography  sx={{fontWeight: 'bold'}}>Quality of Service: </Typography>

<Typography >
I shall ensure the delivery of high-quality healthcare services to patients at all times.
</Typography>



<Typography  sx={{fontWeight: 'bold'}}>Time Commitment: </Typography>

<Typography >
I shall honour the times I commit for counselling.
</Typography>

<Typography  sx={{fontWeight: 'bold'}}>Feedback and Improvement: </Typography>

<Typography >
I shall be open to feedback and continuous improvement, both from patients and Ananth Jeevan.
</Typography>

<Typography  sx={{fontWeight: 'bold'}}>Termination of Partnership: </Typography>

<Typography >
I understand that Ananth Jeevan reserves the right to terminate the partnership if I fail to meet these terms and conditions or breach any applicable laws or ethical standards.
</Typography>

<Typography  sx={{fontWeight: 'bold'}}>Conflicts of Interest: </Typography>

<Typography >
I shall disclose any potential conflicts of interest that may affect my ability to provide unbiased medical advice or treatment.
</Typography>


<Typography  sx={{fontWeight: 'bold'}}>Communication with Ananth Jeevan: </Typography>

<Typography >
I shall maintain open and regular communication with Ananth Jeevan regarding my availability, changes in practice, or any issues that may arise.
</Typography>


<Typography  sx={{fontWeight: 'bold'}}>Indemnification: </Typography>

<Typography >
I agree to indemnify and hold Ananth Jeevan harmless from any claims, damages, or liabilities arising from your actions or services provided as part of this partnership.
</Typography>


<Typography  sx={{fontWeight: 'bold'}}>Modification of Terms:</Typography>

<Typography >
I understand that Ananth Jeevan reserves the right to modify these terms and conditions, and any such changes will be communicated to me in a timely manner.
</Typography>

<Grid item xs={12} sm={4} sx={{ paddingLeft:"100px"}}> 
<Checkbox
  checked={acceptterms}
        onClick={acceptHandle}
                    />
                 
              <InputLabel
              
              
              >
               I Accept
              </InputLabel>
</Grid>

<Grid item xs={12} sm={4} sx={{ paddingLeft:"100px"}}>
<Checkbox
  checked={donotacceptterms}
        onClick={notaccepthandle}
                    />
                 
              <InputLabel
                sx={{
                
                  color:"red"
                }}
              
              >
               I Do Not Accept
              </InputLabel>
</Grid>
          


        </Box>
       
      </Modal>
   

      </Paper>
        );

    }
    export default DoctorRegistration 


